import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from "react";
import { ChevronLeft, Eye, EyeOff } from "lucide-react";
import { useNavigate } from "react-router";
import { Input } from "../../primitives/Input";
import { Button } from "../../primitives/Button";
import { useAuth } from "../../provider";
import { AuthLayout } from "./AuthLayout";
export function LoginPasswordEntry() {
    const navigate = useNavigate();
    const { login, setSessionToken, setEmail: setAuthEmail, setRequiresSetup, authClient, } = useAuth();
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [showPassword, setShowPassword] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);
    const handleSignIn = async () => {
        setIsLoading(true);
        setError(null);
        try {
            const res = await authClient.loginPassword(email, password);
            const result = res.data;
            if (result.challenge_name === "NEW_PASSWORD_REQUIRED") {
                setSessionToken(result.session);
                setAuthEmail(email);
                navigate("/auth/new-password");
            }
            else if (result.challenge_name === "SOFTWARE_TOKEN_MFA") {
                setSessionToken(result.session);
                setAuthEmail(email);
                navigate("/auth/mfa");
            }
            else {
                // Successful login — token is in HttpOnly cookie, not in JS.
                // Use expires_in to schedule proactive refresh.
                login(result.expires_in);
                setRequiresSetup(true);
                navigate("/setup/mfa");
            }
        }
        catch {
            setError("Incorrect email or password");
            setPassword("");
            setShowPassword(false);
        }
        finally {
            setIsLoading(false);
        }
    };
    return (_jsxs(AuthLayout, { children: [_jsx("button", { onClick: () => navigate("/auth"), className: "mb-6 p-2 -ml-2 text-duvi-text-secondary hover:text-duvi-text-primary hover:bg-duvi-elevated rounded transition-colors", title: "Back", children: _jsx(ChevronLeft, { className: "w-5 h-5" }) }), _jsx("h1", { className: "text-duvi-text-primary mb-6", style: {
                    fontSize: "var(--text-xl)",
                    fontWeight: "var(--font-weight-semibold)",
                    lineHeight: "var(--line-height-heading)",
                }, children: "Sign in" }), _jsxs("div", { className: "space-y-4 mb-6", children: [_jsxs("div", { children: [_jsx("label", { className: "block text-duvi-text-primary mb-2", style: { fontSize: "var(--text-sm)" }, children: "Email" }), _jsx(Input, { type: "email", value: email, onChange: (e) => setEmail(e.target.value), placeholder: "Email address", "data-testid": "login-email" })] }), _jsxs("div", { children: [_jsx("label", { className: "block text-duvi-text-primary mb-2", style: { fontSize: "var(--text-sm)" }, children: "Password" }), _jsxs("div", { className: "relative", children: [_jsx(Input, { type: showPassword ? "text" : "password", value: password, onChange: (e) => setPassword(e.target.value), placeholder: "Enter your password", "data-testid": "login-password" }), _jsx("button", { type: "button", onClick: () => setShowPassword(!showPassword), className: "absolute right-3 top-1/2 -translate-y-1/2 text-duvi-text-secondary hover:text-duvi-text-primary transition-colors", children: showPassword ? (_jsx(EyeOff, { className: "w-4 h-4" })) : (_jsx(Eye, { className: "w-4 h-4" })) })] })] })] }), error && (_jsx("div", { className: "mb-4 text-duvi-destructive", "data-testid": "login-error", style: { fontSize: "var(--text-sm)" }, children: error })), _jsx(Button, { variant: "primary", className: "w-full mb-4", onClick: handleSignIn, disabled: isLoading, "data-testid": "login-submit", children: isLoading ? "Signing in..." : "Sign in" }), _jsx("div", { className: "text-center mb-4", children: _jsx("button", { onClick: () => navigate("/auth/forgot-password"), className: "text-duvi-text-secondary hover:text-duvi-text-primary transition-colors", style: { fontSize: "var(--text-xs)" }, children: "Forgot password?" }) })] }));
}
//# sourceMappingURL=LoginPasswordEntry.js.map